export const NOW_PLAYING_GUIDE_ID = 'nowPlaying';
export const RECENTS_GUIDE_ID = 'recents';
